// import { AfterContentInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
// //import { environment } from '../../../environments/environment';
// import { Title } from '@angular/platform-browser';
// import { DOCUMENT } from '@angular/common';
// //import { EnvironmentInfo } from 'src/app/models/EnvironmentInfo';
// //import { EnvironmentsService } from 'src/app/services/environments/environments.service';
// import { Observable, Subscription } from 'rxjs';
// //import { ProjectPermissions } from 'src/app/modules/shared/models/Project';
// //import { ActiveProjectService } from 'src/app/modules/shared/services/activeProject/activeProject.service';
// //import { CurrentUser } from 'src/app/modules/shared/models/currentUser';
// //import { AuthenticationService } from '../../modules/shared/services/authentication/Authentication.service';
// import { Router } from '@angular/router';
// import { ProfileStandardClaims } from 'projects/shared/src/lib/models/profile-standard-claims';
// import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';
// import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
// import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
// @Component({
//   selector: 'app-header',
//   templateUrl: './header.component.html',
//   styleUrls: ['./header.component.scss']
// })
// export class HeaderComponent implements OnInit {

//   title = 'app';
//   name ="";
//   profileData$!: Observable<ProfileStandardClaims>;

//   // public user: CurrentUser = new CurrentUser;
//   // public env: EnvironmentInfo;
//   // public projectPermissions: ProjectPermissions = null;
//   // private Subscriptions: Subscription[] = [];

//   constructor(private titleService:Title,
//     private userProfileService: UserProfileService,
//     private oauthService: OAuthServiceService,
//     private tenantService: TenantService,

//     // public activeProjectService: ActiveProjectService,
//     // public environmentsService: EnvironmentsService,
//     // public AuthenticationService: AuthenticationService,
//     public router: Router,
//     @Inject(DOCUMENT) private _document: Document) {
//     this.titleService.setTitle("Squirrel");
//   }

//   ngOnInit() {
//     var self = this;
//     // this._document.getElementById('appFavicon').setAttribute('href', './assets/favicon/favicon.ico');
//     // self.Subscriptions.push(self.environmentsService.onSetEnvironment.subscribe((env: EnvironmentInfo) => self.env = env));
//     // self.Subscriptions.push(self.activeProjectService.onChangeProject.subscribe(() => self.changeProject()));
//     // self.Subscriptions.push(this.AuthenticationService.setUsername.subscribe(value => this.onLoginChanged(value)));
//     // this.projectPermissions = this.activeProjectService.projectPermissions;

//   }

//   get username(): string {
//     this.name = this.userProfileService.currentUserName;
//     if (this.name != null) return this.name;
//     this.profileData$ = this.oauthService.userData;
//     this.profileData$.subscribe((data) => {
//         if (data != null)
//             this.name = data?.name as string;
//         else
//         this.name = '';
//     });
//     this.userProfileService.currentUserName = this.name;
//     return this.name;
// }

//   // onLoginChanged(value: CurrentUser) {
//   //   this.user = value;
//   //   this.env = this.environmentsService.getCurrentEnvironment();
//   // }

//   // ngOnDestroy() {
//   //   for(var subs of this.Subscriptions) {
//   //     subs.unsubscribe();
//   //   }
//   // }

//   // changeProject(): void {
//   //   this.projectPermissions = this.activeProjectService.projectPermissions;
//   // }

//   // logoLeft(): string {
//   //   return environment.logoLeft;
//   // }

//   // logoRight(): string {
//   //   return environment.logoRight;
//   // }

//   // projects() {
//   //   if (this.env.isExternal) return;
//   //   if (this.user.tenant) return;
//   //   this.router.navigateByUrl("/"+this.env.systempath+"/projects");
//   // }

//   // logout() {
//   //   if (this.env) {
//   //     this.AuthenticationService.logout(this.env.systempath);
//   //   }
//   //   else {
//   //     this.router.navigateByUrl("/logout");
//   //   }
//   // }
// }


import { AfterContentInit, Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UserActions, ROUTES, USERACTIONS, UserInfos, SIGNOUT } from 'projects/shared/src/lib/models/IMenuItem';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { Observable } from 'rxjs';
import { ProfileStandardClaims } from 'projects/shared/src/lib/models/profile-standard-claims';
import { DataSharingService } from 'projects/shared/src/lib/services/data-sharing.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterContentInit {

    //avatar: string = './assets/img/avatar-emty.png';

    items: UserActions[] = [];
    userInfos: UserInfos[] = [];
    private listTitles!: any[];

    location: Location;
    // mobile_menu_visible: any = 0;
    mobile_menu_visible: number = 0;
    private toggleButton: any;
    private sidebarVisible: boolean;

    profileData$!: Observable<ProfileStandardClaims>;
    name = '';
    activeProjectName!: string;
    tenantName = '';
    tenantImage: string | ArrayBuffer | null = null;


    constructor(location: Location,
        private element: ElementRef,
        private router: Router,
        private oauthService: OAuthServiceService,
        private tenantService: TenantService,
        private userProfileService: UserProfileService,
        private dataSharingService: DataSharingService,
        public translate: TranslateService) {
        this.location = location;
        this.sidebarVisible = false;
    }

    ngOnInit() {
        this.tenantName = (this.tenantService.currentTenantName) ? this.tenantService.currentTenantName.replace("_"," ") : "";
        this.tenantService.getTenant(this.tenantService.currentTenantId).subscribe({
            next: (tenantDto) => {
                    this.tenantImage = tenantDto.image ? 'data:image/png;base64,' + tenantDto.image : null;
            },
            error: (error: any) => {
                
                console.error("------------> header component: get tenant error = ", error);
            }
        });
        //this.tenantName.replace("_"," ");
        this.name = this.userProfileService.currentUserName;
        this.listTitles = ROUTES.filter(listTitle => listTitle);
        (this.tenantService.currentTenantName != null) ? this.items = USERACTIONS : this.items = SIGNOUT;
        //this.items = USERACTIONS;
        // if (this.tenantService.currentTenantName != null) {
        //     let ui = new UserInfos();
        //     ui.label = "TENANTLABEL";
        //     ui.text = this.tenantService.currentTenantName;
        //     this.userInfos.push(ui);
        // }

        // const navbar: HTMLElement = this.element.nativeElement;
        // this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        // this.router.events.subscribe((event) => {
        //     this.sidebarClose();
        //     let $layer: any = document.getElementsByClassName('close-layer')[0];
        //     if ($layer) {
        //         $layer.remove();
        //         this.mobile_menu_visible = 0;
        //     }
        // });
    }

    ngAfterContentInit(): void {
        this.dataSharingService.activeProjectName.subscribe({
            next: (projectName: string) => {

                if (projectName.length !== 0)
                    this.activeProjectName = projectName;
                else
                    this.activeProjectName = 'No Active Project';
            }
        });
    }

    // toSelectTenants(): void {
    //   this.router.navigate(['/', 'select-tenant']);
    // }

    get username(): string {
        this.name = this.userProfileService.currentUserName;       
        if (this.name != null && this.name != "") return this.name;
        this.profileData$ = this.oauthService.userData;
        // console.log("---------> squirrel-top-nav profile data = ", this.profileData$);
        this.profileData$.subscribe((data) => {
            if (data != null)
                this.name = data?.name as string;
            else
            this.name = '';
        });
        this.userProfileService.currentUserName = this.name;
        return this.name;
    }

    // get tenantname(): string {
    //     return this.tenantService.currentTenantName;
    // }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);

        body.classList.add('nav-open');

        this.sidebarVisible = true;
    };

    // sidebarClose() {
    //     const body = document.getElementsByTagName('body')[0];
    //     this.toggleButton.classList.remove('toggled');
    //     this.sidebarVisible = false;
    //     body.classList.remove('nav-open');
    // };

    // sidebarToggle() {
    //     // const toggleButton = this.toggleButton;
    //     // const body = document.getElementsByTagName('body')[0];
    //     let $toggle = document.getElementsByClassName('navbar-toggler')[0];

    //     if (this.sidebarVisible === false) {
    //         this.sidebarOpen();
    //     }
    //     else {
    //         this.sidebarClose();
    //     }
    //     const body = document.getElementsByTagName('body')[0];

    //     let $layer = document.createElement('div');

    //     if (this.mobile_menu_visible == 1) {
    //         // $('html').removeClass('nav-open');
    //         body.classList.remove('nav-open');
    //         if ($layer) {
    //             $layer.remove();
    //         }
    //         setTimeout(function () {
    //             $toggle.classList.remove('toggled');
    //         }, 400);

    //         this.mobile_menu_visible = 0;
    //     }
    //     else {
    //         setTimeout(function () {
    //             $toggle.classList.add('toggled');
    //         }, 430);

    //         // let $layer = document.createElement('div');
    //         $layer.setAttribute('class', 'close-layer');

    //         if (body.querySelectorAll('.main-panel')) {
    //             document.getElementsByClassName('main-panel')[0].appendChild($layer);
    //         } else if (body.classList.contains('off-canvas-sidebar')) {
    //             document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
    //         }

    //         setTimeout(function () {
    //             $layer.classList.add('visible');
    //         }, 100);

    //         $layer.onclick = function () { //asign a function
    //             body.classList.remove('nav-open');
    //             //this.mobile_menu_visible = 0;              
    //             $layer.classList.remove('visible');
    //             setTimeout(function () {
    //                 $layer.remove();
    //                 $toggle.classList.remove('toggled');
    //             }, 400);
    //         }.bind(this);

    //         body.classList.add('nav-open');
    //         this.mobile_menu_visible = 1;
    //     }
    // };

    getTitle() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }

        for (var item = 0; item < this.listTitles.length; item++) {
            if (this.listTitles[item].path === titlee) {
                return this.listTitles[item].title;
            }
        }
        return 'Dashboard';
    }

}
